export const WEEKDAYS_REF = [
  { label: "Lunes", abbrev: "LU", value: 2 },
  {
    label: "Martes",
    abbrev: "MA",
    value: 3,
  },
  { label: "Miércoles", abbrev: "MI", value: 4 },
  { label: "Jueves", abbrev: "JU", value: 5 },
  {
    label: "Viernes",
    abbrev: "VI",
    value: 6,
  },
  { label: "Sábado", abbrev: "SA", value: 7 },
  { label: "Domingo", abbrev: "DO", value: 1 },
];

/**
 * Convierte los días de la semana de acuerdo a la especificación de base de datos.
 * Números del 1 al 7 empezando en domingo.
 * @param {string} weekDays - Números de los días de la semana separados por coma.
 * @param {boolean} useAbbrev - Indica si se utilizará 'SA' en lugar de 'SÁBADO'.
 */
export const weekDaysNumbersToESText = (weekDays, useAbbrev = false) =>
  weekDays
    .split(",")
    .map((day) =>
      useAbbrev
        ? WEEKDAYS_REF.find((dayData) => dayData.value.toString() === day)
            .abbrev
        : WEEKDAYS_REF.find((dayData) => dayData.value.toString() === day).label
    )
    .join(", ");

/**
 * Aplica formato de número telefónico 'XXX-XXX-XXXX' al número indicado.
 * @param {string} input - Texto a formatear
 * @returns Texto formateado.
 */
export const formatAsDOPhone = (input) => {
  input = input.replace(/\D/g, "");
  let value = input;

  if (value.length > 0) {
    // Format as XXX-XXX-XXXX
    if (value.length <= 3) {
      value = input;
    } else if (value.length <= 6) {
      value = value.slice(0, 3) + "-" + value.slice(3);
    } else {
      value =
        value.slice(0, 3) + "-" + value.slice(3, 6) + "-" + value.slice(6, 10);
    }
  }

  return value;
};
